import MainContainer from '@blocks/MainContainer'
import ClubController from '@club/admin/api/ClubController'
import Table from '@components/modules/Table'
import useRequestEffect from '@hooks/useRequestEffect'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import columns from './config/columns'
import useClubsTableOptions from './hooks/useClubsTableOptions'

export default function ClubsPage() {
    useTitle("Groups")
    useMainTemplate({ category: "clubs" })
    
    const [clubs, setClubs] = useRequestEffect(ClubController.index, {
        cache: "clubs"
    })

    const options = useClubsTableOptions()

    return (
        <MainContainer heading="Groups">
            <Table data={clubs} columns={columns} options={options} />
        </MainContainer>
    )
}